/**
 * Which GKV supply contract a Heilmittel position is priced under.
 *
 * - `125`  — Regelversorgung, the contracts under § 125 Abs. 1 SGB V.
 * - `125a` — Blankoverordnung, the contracts under § 125a SGB V.
 *
 * The Heilmittelpreisstammdatei carries no contract field, but the split is
 * derivable from the Positionsnummer itself: the X-masked form (`X0501`) is the
 * § 125 catalogue — `X` is the wildcard for the Leistungserbringer digit — while
 * § 125a positions are published as plain numbers (`54445`). 160 of the file's
 * 229 rows are X-masked, 69 are numeric.
 *
 * Not every Bereich has both. Only Physiotherapie and Ergotherapie have a § 125a
 * Anlage 2 at all; Ernährungstherapie, Podologie and the Stimm-, Sprech-Sprach-
 * und Schlucktherapie publish § 125 only.
 */
export var GkvVertrag;
(function (GkvVertrag) {
    GkvVertrag["PARAGRAPH_125"] = "125";
    GkvVertrag["PARAGRAPH_125A"] = "125a";
})(GkvVertrag || (GkvVertrag = {}));
/**
 * The contract a Positionsnummer belongs to, read off its own shape. The masked
 * `X` form stays the permanent catalogue key (ADR-0032); resolving it to an
 * emittable number happens at emit time.
 */
export function gkvVertragOf(posNumber) {
    return posNumber.trim().toUpperCase().startsWith('X')
        ? GkvVertrag.PARAGRAPH_125
        : GkvVertrag.PARAGRAPH_125A;
}
//# sourceMappingURL=gkv-vertrag.enum.js.map